// LLM generated - Model GPT-5.2
import type {
  APIGetPropsIncluded,
  APIGetPropsResponse,
  APIPropExpanded,
  APIRelatedStandaloneProp,
} from '../interfaces/propsService/api';
import type { PublicGame } from '../interfaces/propsService/api/game';
import type { TGetPropsResponse, TPropExpanded } from '../interfaces/propsService/parsed/props';

import parsePropExpanded from './parsePropExpanded';

function findById<T extends { id: string }>(
  items: T[] | undefined,
  id: string | undefined
): T | undefined {
  if (!items?.length || !id) return undefined;
  return items.find((item) => item.id === id);
}

function findGameById(
  games: PublicGame[] | undefined,
  gameId: string | undefined
): PublicGame | undefined {
  if (!games?.length || !gameId) return undefined;
  return games.find((g) => g.id === gameId);
}

/** Merge `included` sideloads onto a row when `entity` / `game` / `team` are absent. */
export function hydratePropRowFromIncluded(
  row: APIPropExpanded | APIRelatedStandaloneProp,
  included?: APIGetPropsIncluded
): APIPropExpanded {
  const withScore = {
    ...row,
    score: row.score ?? 0,
  } as APIPropExpanded;

  if (!included) {
    return withScore;
  }

  return {
    ...withScore,
    entity: withScore.entity ?? findById(included.entities, withScore.entity_id),
    game: withScore.game ?? findGameById(included.games, withScore.game_id),
    team: withScore.team ?? findById(included.teams, withScore.team_id),
  };
}

const parsePropsResponseV1 = (response: APIGetPropsResponse): TGetPropsResponse => {
  const { included } = response;

  const mapRow = (row: APIPropExpanded): TPropExpanded => {
    const hydrated = hydratePropRowFromIncluded(row, included);
    const relatedParsed =
      hydrated.related_props?.map((related) =>
        parsePropExpanded(hydratePropRowFromIncluded(related, included))
      ) ?? undefined;
    const base = parsePropExpanded(hydrated);
    return relatedParsed?.length ? { ...base, relatedProps: relatedParsed } : base;
  };

  return {
    ...response,
    data: response.data.map(mapRow),
  };
};

export default parsePropsResponseV1;
